import { makeStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import type { GroupPost } from '../../types/GroupPost';
import type { Group } from '../../types/Group';
import Post from './post';

const useStyles = makeStyles()((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
}));

type Props = {
  posts?: GroupPost[];
  emptyMessage?: React.ReactNode;
  group?: Group;
};

const GroupPostList = ({ posts, emptyMessage = 'No posts', group }: Props) => {
  const { classes } = useStyles();

  if (!posts || !posts.length) {
    return <p>{emptyMessage}</p>;
  }

  return (
    <Paper className={classes.paper}>
      <ul className={classes.list}>
        {posts.map((post, index) => {
          return (
            <li key={post.id}>
              {index > 0 && <Divider sx={{ my: 2 }} />}
              <Post post={post} group={group} />
            </li>
          );
        })}
      </ul>
    </Paper>
  );
};

export default GroupPostList;
